import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GtmService {

  customEvent(eventName: string, object: {[p: string]: string | number}): void {
    const event = {
      event: eventName,
      ...object
    };
    window['dataLayer'].push(event);
  }

  // --This function rewriting the original script from GTM site--
  // See the original script in comment below:
  // <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  //     new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  //   j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  //   'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  // })(window,document,'script','dataLayer','GTM-NHDBCX7');</script>
  googleTagManagerInit(w: Window, d: Document, s: string, l: string, i: string): void {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start':
        new Date().getTime(), event: 'gtm.js'
    });
    const f = d.getElementsByTagName(s)[0],
      j = d.createElement(s), dl = l !== 'dataLayer' ? '&l=' + l : '';
    // @ts-ignore
    j.async = true;
    // @ts-ignore
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  }

}
